import React, { useRef } from 'react';
import { useReactive } from 'ahooks';
import ConversationList from './components/ConversationList/index';
import ChatArea from './components/ChatArea';
import AssetLibrary from './components/AssetLibrary';
import styles from './index.less';

// 三种创作模式
const MODES = {
  CHAT: 'chat',
  IMAGE: 'image',
  VIDEO: 'video',
};

const AiCreationCenter = () => {
  const state = useReactive({
    mode: MODES.IMAGE, // 当前模式
    currentConversationId: null, // 当前会话ID
    assetLibraryVisible: false, // 资产库是否展开
  });

  const chatAreaRef = useRef();
  const conversationListRef = useRef();

  // 切换模式
  const handleModeChange = (mode) => {
    state.mode = mode;
  };

  // 选择会话
  const handleSelectConversation = (id) => {
    state.currentConversationId = id;
  };

  // 新建会话
  const handleNewConversation = () => {
    state.currentConversationId = null;
    chatAreaRef.current?.clearMessages();
  };

  // 切换资产库
  const toggleAssetLibrary = () => {
    state.assetLibraryVisible = !state.assetLibraryVisible;
  };

  return (
    <div className={styles.container}>
      {/* 左侧：对话列表 */}
      <div className={styles.sidebar}>
        <ConversationList
          ref={conversationListRef}
          currentId={state.currentConversationId}
          onSelect={handleSelectConversation}
          onNew={handleNewConversation}
        />
      </div>

      {/* 中间：聊天区域 */}
      <div className={styles.main}>
        <ChatArea
          ref={chatAreaRef}
          mode={state.mode}
          conversationId={state.currentConversationId}
          onModeChange={handleModeChange}
          onToggleAssetLibrary={toggleAssetLibrary}
        />
      </div>

      {/* 右侧：资产库 */}
      {state.assetLibraryVisible && (
        <div className={styles.assetPanel}>
          <AssetLibrary onClose={toggleAssetLibrary} />
        </div>
      )}
    </div>
  );
};

export default AiCreationCenter;
